define('admin/companies/index',['jquery', 'plugins/http', 'knockout', 'durandal/app'], function ($, http, ko, app) {
    var viewmodel = function () {
        var self = this;

        self.companies = ko.observableArray([]);
        self.hasCompanies = ko.computed(function () {
            return self.companies().length > 0;
        });
        
        // new company fields:
        self.name = ko.observable();
        self.description = ko.observable();
        self.adminEmail = ko.observable();
        self.adminName = ko.observable();
        self.attribution = ko.observable();
        self.mapboxApiKey = ko.observable();
        self.maptilerApiKey = ko.observable();
        self.tileLayerName = ko.observable();
        self.tileLayerId = ko.observable();

        self.activate = function () {
            self.refresh();
        };

        self.refresh = function () {
            var url = '/api/admin/companies/list';

            self.companies.removeAll();
            self.resetForm();

            http.get(url)
                .then(function (response) {
                    var data = response.data.companies,
                        companiesLen = data.length;

                    if (companiesLen > 0) {
                        // adds all companies to observableArray in one go
                        var spliceArgs = [0, 0].concat(data);
                        self.companies.splice.apply(self.companies, spliceArgs);
                    }
                }).fail(app.showError);
        };

        self.resetForm = function () {
            self.name('');
            self.description('');
            self.adminEmail('');
            self.adminName('');
            self.attribution('');
            self.mapboxApiKey('');
            self.maptilerApiKey('');
            self.tileLayerName('');
            self.tileLayerId('');
        };

        self.createCompanyCommand = function() {
            self.createCompany()
                .then(self.refresh);
        };

        self.createCompany = function () {
            var url = '/api/admin/companies/create',
                data = {
                    name: self.name(),
                    description: self.description(),
                    adminEmail: self.adminEmail(),
                    adminName: self.adminName(),
                    attribution: self.attribution(),
                    mapboxApiKey: self.mapboxApiKey(),
                    maptilerApiKey: self.maptilerApiKey(),
                    tileLayerName: self.tileLayerName(),
                    tileLayerId: self.tileLayerId(),
                };

            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return viewmodel;
});
